import { render, staticRenderFns } from "./AiDialogueAction.vue?vue&type=template&id=9b842c4e&scoped=true&"
import script from "./AiDialogueAction.vue?vue&type=script&lang=js&"
export * from "./AiDialogueAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b842c4e",
  null
  
)

export default component.exports